import { useEffect, useState } from 'react'
import { ModalDialog, Mtds } from 'prove-common'

type Props = {
  open: boolean
  onClose: () => void
  onCodeEntered: (code: string) => void
}

export const ManualCodeEntryModal = ({
  open,
  onClose,
  onCodeEntered
}: Props) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    if (open) setValue('')
  }, [open])

  return (
    <ModalDialog
      id='manual-code-entry-modal'
      open={open}
      onClose={(e) => {
        e?.stopPropagation()
        onClose()
      }}
    >
      <Mtds.Button
        command='close'
        commandfor='manual-code-entry-modal'
        aria-label={'Lukk'}
      />
      <Mtds.Prose>
        <Mtds.Heading>Fungerer ikke kodeleseren?</Mtds.Heading>
        <p>
          Her kan du skrive inn koden manuelt eller bruke håndholdt skanner. Vær
          ekstra påpasselig med at det blir riktig kode. Det vil ikke være mulig
          å endre i ettertid.
        </p>
        <Mtds.Field>
          <label htmlFor='code-input'>Skriv inn kode</label>
          <Mtds.Input
            id='code-input'
            autoFocus
            value={value}
            placeholder='Kode'
            onChange={(e) => setValue(e.target.value.toUpperCase())}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault()
                onCodeEntered(value)
              }
            }}
          />
        </Mtds.Field>
        <Mtds.Flex>
          <Mtds.Button command='close' commandfor='manual-code-entry-modal'>
            Avbryt
          </Mtds.Button>
          <Mtds.Button
            data-variant='primary'
            onClick={(e) => {
              e.preventDefault()
              onCodeEntered(value)
            }}
          >
            Bruk kode
          </Mtds.Button>
        </Mtds.Flex>
      </Mtds.Prose>
    </ModalDialog>
  )
}
